import { Link } from 'react-router-dom';
import { stats } from '@/mocks/welfare';

export default function AboutBrief() {
  return (
    <section className="py-14 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-2xl border border-background-200 p-8 md:p-12">
          <div className="flex flex-col lg:flex-row items-center gap-10">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-4">关于福利导航网</h2>
              <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-lg">
                福利导航网成立于2024年，是国内领先的一站式福利资源聚合平台。我们致力于为用户汇集全网最优质的优惠券、折扣活动、会员福利、返利信息及限时特惠，让每一位用户都能轻松省钱，享受品质生活。
              </p>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                了解更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 w-full lg:w-auto">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center p-4 rounded-xl bg-background-100 min-w-[110px]">
                  <div className="text-2xl md:text-3xl font-bold text-primary-500 mb-1 font-heading">{stat.value}</div>
                  <div className="text-xs text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}